import { Pipe, PipeTransform } from '@angular/core';
import {DistanceType} from "../types/distance.type";

@Pipe({name: 'distance'})
export class DistancePipe implements PipeTransform {
  transform(distance, fractionDigits: number = 2): DistanceType {
    if(!distance) return;

    let output;
    let units;

    if(distance > 1000 ){
      units = 'km';
    } else {
      units = 'm'
    }

    switch(units){
      case 'km':
        output = distance / 1000;
        break;
      case 'm':
        output = distance;
        break;
    }

    output = output.toFixed(fractionDigits) + ' ' + units;

    return {
      km: (distance / 1000).toFixed(fractionDigits),
      m: distance.toFixed(fractionDigits),
      unitsSuggestion: units,
      computed: output,
    };
  }
}



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/pipes/distance.pipe.ts